import { useEffect, useState, useSize } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FixedSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import ProfileCard from './ProfileCard';
import { Paper, Stack, useTheme } from '@mui/material';
import SearchBar from './SearchBar';
import { variants } from '../../../variants/variants';
import { useDispatch, useSelector } from 'react-redux';
import { resetSearch, searchFulfilled, selectHasNextPage, selectUsers } from '../searchSlice';
import ProfileSkeleton from './ProfileSkeleton';
import { useLazySearchEmployeeQuery } from '../searchApiSlice';
import GGbot from './GGbot';

const ProfileList = () => {
  const theme = useTheme();
  const [isNextPageLoading, setIsNextPageLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentPath = pathname.split('/')[4];
  const users = useSelector(selectUsers);
  const hasNextPage = useSelector(selectHasNextPage);
  const [search, setSearch] = useState({
    page: 1,
    searchTerm: '',
    selectedFilter: '',
  });

  const [searchEmployee] = useLazySearchEmployeeQuery();
  const [onInput, setOnInput] = useState(false);
  const handleSearchChange = e => {
    const value = e.target.value;
    let newSearch = { ...search, page: 1, searchTerm: value };
    setSearch(newSearch);
    setOnInput(true);
  };

  const handleProfileClick = empCode => {
    if (currentPath) {
      // navigate(`chats/${empCode}/${currentPath}`);
      navigate(`/home/chats/${empCode}`);
    } else {
      navigate(`/home/chats/${empCode}`);
    }
  };

  const loadNextPage = () => {
    setIsNextPageLoading(true);
    const fetchData = async () => {
      try {
        const data = await searchEmployee(search, { preferCacheValue: true }).unwrap();
        setSearch(state => {
          return { ...state, page: state.page + 1 };
        });
        setIsNextPageLoading(false);
        dispatch(searchFulfilled(data));
      } catch (err) {
        console.log('load next page error', err);
      }
    };
    fetchData();
  };

  // If there are more items to be loaded then add an extra row to hold a loading indicator.
  const itemCount = hasNextPage ? (users.length === 0 ? 11 : users.length + 1) : users.length;

  // Only load 1 page of items at a time.
  // Pass an empty callback to InfiniteLoader in case it asks us to load more than once.
  const loadMoreItems = isNextPageLoading ? () => {} : loadNextPage;

  // Every row is loaded except for our loading indicator row.
  const isItemLoaded = index => !hasNextPage || index < users.length;

  // Render an item or a loading indicator.
  const Item = ({ index, style }) => {
    if (!isItemLoaded(index)) {
      return <ProfileSkeleton style={style} />;
    }

    return <ProfileCard content={users[index]} handleProfileClick={handleProfileClick} style={style} key={index} />;
  };

  //debouncing search api call
  useEffect(() => {
    const debounce = setTimeout(async () => {
      try {
        if (!onInput) {
          setSearch({
          page: 1,
          searchTerm: '',
          selectedFilter: '',
        })
        const data = await searchEmployee(search, { preferCacheValue: true }).unwrap();
        dispatch(resetSearch());
        dispatch(searchFulfilled(data));
         return;}
        const data = await searchEmployee(search, { preferCacheValue: true }).unwrap();
        dispatch(resetSearch());
        dispatch(searchFulfilled(data));
        setSearch(state => {
          return { ...state, page: state.page + 1 };
        });
      } catch (err) {
        console.log('debounce search', err);
      }
    }, 100);

    return () => clearTimeout(debounce);
  }, [search.searchTerm,onInput]);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: variants.boxRadius.SIDEBAR,
        border: 1,
        borderColor: 'divider',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SearchBar
        handleSearchChange={handleSearchChange}
        value={search.searchTerm}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          '.MuiOutlinedInput-root > fieldset': {
            border: 'none',
          },
        }}
      />
      <GGbot />
      <InfiniteLoader isItemLoaded={isItemLoaded} itemCount={itemCount} loadMoreItems={loadMoreItems}>
        {({ onItemsRendered, ref }) => (
          <Stack className='content' sx={{ display: 'flex', flexGrow: 1, position: 'relative', height:0 }}>
            <List
              //height={592}
              height={592}
              itemCount={itemCount}
              itemSize={60}
              onItemsRendered={onItemsRendered}
              ref={ref}
              width={'100%'}
              // className='dynamic-height'
              style={{
                flexGrow: 1,
                // maxHeight: 'calc(100vh - 400px)',
                // [theme.breakpoints.down('md')]: {
                //   maxHeight: 'calc(100vh - 335px)',
                // },
              }}
            >
              {Item}
            </List>
          </Stack>
        )}
      </InfiniteLoader>
    </Paper>
  );
};

export default ProfileList;
